import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newdesign',
  templateUrl: './newdesign.component.html',
  styleUrls: ['./newdesign.component.scss']
})
export class NewdesignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
